import React from 'react';
import styled from 'styled-components';
import { numStringToCss, prop } from '@bit/daviidli.corn-ui.utils';
const Container = styled.div `
	position: fixed;
	transition: ${p => (!p.Open ? 'left 1ms linear 1s' : 'left 0s linear 0s')},
		${p => (!p.Open ? 'left 1ms linear 1s' : 'left 0s linear 0s')},
		${p => (p.Open ? 'clip-path 0.3s ease-in' : 'clip-path 0.35s ease-out 0.25s')};
	top: 0px;
	left: ${p => (p.Open ? '0px' : `-${numStringToCss(p.Width)}`)};
	width: ${p => numStringToCss(p.Width)};
	height: 100%;
	padding-top: ${p => `calc(${p.Top} + ${p.ButtonDimensions}px + 1rem)`};
	overflow-y: ${p => (p.Open ? 'auto' : 'hidden')};
	background: ${prop('PanelColor')};
	clip-path: ${p => {
    const halfButton = p.ButtonDimensions / 2;
    if (p.Open) {
        return `circle(150% at calc(${p.Top} + ${halfButton}px) calc(${p.Left} + ${halfButton}px))`;
    }
    return `circle(0% at calc(${p.Top} + ${halfButton}px) calc(${p.Left} + ${halfButton}px))`;
}};
`;
const SideBarPanel = (props) => {
    const { open, children, top, left, width, panelColor, buttonDimensions } = props;
    return (React.createElement(Container, { className: "corn-sidebar-panel", Open: open, Width: width || '300px', Top: top, Left: left, PanelColor: panelColor, ButtonDimensions: buttonDimensions }, children));
};
export default SideBarPanel;
